export enum STORAGE_TYPE {
  S3 = 's3',
  AZURE = 'azure',
}
